import { Link } from 'react-router-dom';
import Navigation from '../../../components/feature/Navigation';

function Hero() {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900">
      <Navigation />
      
      {/* Hero Content */}
      <div className="relative pt-32 pb-20 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center">
            {/* Headline */}
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              App Success Intelligence™ for Founders Who Want Real Answers
            </h1>
            
            {/* Sub-headline */}
            <p className="text-xl md:text-2xl text-slate-300 mb-12 max-w-4xl mx-auto leading-relaxed">
              CrowdRounds delivers objective, bias-free evaluations using structured intelligence, proven benchmarks, and advanced scoring — not guesses, opinions, or paid testers.
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/pricing" 
                className="px-8 py-4 bg-teal-500 text-white font-bold rounded-lg hover:bg-teal-600 transition-colors text-lg whitespace-nowrap cursor-pointer inline-block"
              >
                Evaluate My App
              </Link>
              <Link 
                to="/tier-comparison" 
                className="px-8 py-4 bg-white text-slate-900 font-bold rounded-lg hover:bg-slate-100 transition-colors text-lg whitespace-nowrap cursor-pointer inline-block"
              >
                Compare Tiers
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl"></div>
      </div>
    </div>
  );
}

export default Hero;
